import { Menu as BaseMenu } from '@base-ui/react';

import { MenuExternalLinkItem } from './MenuExternalLinkItem';
import { MenuItem } from './MenuItem';
import { MenuLinkItem } from './MenuLinkItem';
import { MenuList } from './MenuList';
import { MenuRoot } from './MenuRoot';

export const Menu = {
  Root: MenuRoot,
  Trigger: BaseMenu.Trigger,
  List: MenuList,
  Item: MenuItem,
  LinkItem: MenuLinkItem,
  ExternalLinkItem: MenuExternalLinkItem,
};
